import clsx from "clsx";
import Image from "next/image";
import { Card } from "@chef/components";

interface ProductCardProps {
  imageUrl: string;
  title: string;
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

export const ProductCard = ({
  imageUrl,
  title,
  className,
  children,
  onClick,
}: ProductCardProps) => {
  return (
    <Card
      noPadding
      className={clsx("relative h-28 flex flex-col flex-1", className)}
    >
      <div className="relative flex h-full">
        <button
          type="button"
          onClick={onClick}
          className="relative aspect-square"
        >
          <Image
            alt={title}
            src={imageUrl}
            fill
            className="object-cover rounded-tl"
            sizes="(min-width: 768px) 25vw, 20vw"
          />
        </button>

        <div className="flex flex-col justify-between w-full  md:px-2.5 px-3 py-2 md:py-3 grow">
          <button
            type="button"
            onClick={onClick}
            className="flex items-start text-left grow line-clamp-2 max-h-12"
          >
            {title}
          </button>

          <div className="flex items-end justify-between w-full ">
            {children}
          </div>
        </div>
      </div>
    </Card>
  );
};
